(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const el = document.querySelector('.collection__togglers');

  window.addEventListener('scroll', () => {
    el.classList.toggle('is-stuck', window.scrollY >= el.offsetTop);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  (function () {
    const backBtn = document.querySelector('.general-page__back-btn');
    const sidebar = document.querySelector('.general-page__sidebar');
    const overlay = document.querySelector('.general-page__overlay');
    const wrapper = document.querySelector('.general-page__wrapper');

    if (backBtn && sidebar && overlay && wrapper) {
      function toggleSidebar() {
        wrapper.classList.toggle('general-page__wrapper--sidebar-active');
        document.body.classList.toggle('general-page-sidebar-open');
      }

      function closeSidebar() {
        wrapper.classList.remove('general-page__wrapper--sidebar-active');
        document.body.classList.remove('general-page-sidebar-open');
      }

      backBtn.addEventListener('click', toggleSidebar);
      overlay.addEventListener('click', closeSidebar);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSidebar();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"]) return;
  try {
    
  (function () {
    const backBtn = document.querySelector('.general-page__back-btn');
    const sidebar = document.querySelector('.general-page__sidebar');
    const overlay = document.querySelector('.general-page__overlay');
    const wrapper = document.querySelector('.general-page__wrapper');

    if (backBtn && sidebar && overlay && wrapper) {
      function toggleSidebar() {
        wrapper.classList.toggle('general-page__wrapper--sidebar-active');
        document.body.classList.toggle('general-page-sidebar-open');
      }

      function closeSidebar() {
        wrapper.classList.remove('general-page__wrapper--sidebar-active');
        document.body.classList.remove('general-page-sidebar-open');
      }

      backBtn.addEventListener('click', toggleSidebar);
      overlay.addEventListener('click', closeSidebar);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSidebar();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (function () {
    const backBtn = document.querySelector('.general-page__back-btn');
    const sidebar = document.querySelector('.general-page__sidebar');
    const overlay = document.querySelector('.general-page__overlay');
    const wrapper = document.querySelector('.general-page__wrapper');

    if (backBtn && sidebar && overlay && wrapper) {
      function toggleSidebar() {
        wrapper.classList.toggle('general-page__wrapper--sidebar-active');
        document.body.classList.toggle('general-page-sidebar-open');
      }

      function closeSidebar() {
        wrapper.classList.remove('general-page__wrapper--sidebar-active');
        document.body.classList.remove('general-page-sidebar-open');
      }

      backBtn.addEventListener('click', toggleSidebar);
      overlay.addEventListener('click', closeSidebar);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSidebar();
        }
      });
    }

    // Wrap tables for horizontal scroll on mobile
    const contentArea = document.querySelector('.general-page__text');
    if (contentArea) {
      const tables = contentArea.querySelectorAll('table');
      tables.forEach((table) => {
        if (!table.parentElement.classList.contains('table-wrapper')) {
          const tableWrapper = document.createElement('div');
          tableWrapper.className = 'table-wrapper';
          table.parentNode.insertBefore(tableWrapper, table);
          tableWrapper.appendChild(table);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const linkStars = document.querySelector('a[href="#shopify-product-reviews"]');
  if (linkStars) {
    linkStars.addEventListener('click', function (e) {
      e.preventDefault();
      const reviewsSection = document.getElementById('judgeme_product_reviews');
      if (reviewsSection) {
        const offsetTop = reviewsSection.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const viewToggle2 = document.getElementById('view_toggle_2');
    const viewToggle4 = document.getElementById('view_toggle_4');
    const viewToggle5 = document.getElementById('view_toggle_5');
    const collection = document.querySelector('.collection');
    const collectionItems = document.querySelector('.collection__items');

    let currentView = 4;

    if (collection) {
      if (window.innerWidth < 768) {
        collection.classList.add('collection--grid-2');
        if (viewToggle2) 
          viewToggle2.classList.add('active');
        
        currentView = 2;
      } else {
        collection.classList.add('collection--grid-4');
        if (viewToggle4) 
          viewToggle4.classList.add('active');
        
        currentView = 4;
      }
    }

    function updateGridView(gridSize) {
      collection.classList.remove('collection--grid-2', 'collection--grid-4', 'collection--grid-5');

      if (viewToggle2) 
        viewToggle2.classList.remove('active');
      
      if (viewToggle4) 
        viewToggle4.classList.remove('active');
      
      if (viewToggle5) 
        viewToggle5.classList.remove('active');
      

      collection.classList.add(`collection--grid-${gridSize}`);

      if (gridSize === 2 && viewToggle2) {
        viewToggle2.classList.add('active');
      } else if (gridSize === 4 && viewToggle4) {
        viewToggle4.classList.add('active');
      } else if (gridSize === 5 && viewToggle5) {
        viewToggle5.classList.add('active');
      }

      currentView = gridSize;
    }

    if (viewToggle2) {
      viewToggle2.addEventListener('click', function() {
        updateGridView(2);
      });
    }

    if (viewToggle4) {
      viewToggle4.addEventListener('click', function() {
        updateGridView(4);
      });
    }

    if (viewToggle5) {
      viewToggle5.addEventListener('click', function() {
        updateGridView(5);
      });
    }

    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (window.innerWidth < 768 && currentView === 5) {
          updateGridView(2);
        } else if (window.innerWidth >= 768 && currentView === 2) {
          updateGridView(4);
        }
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
